import type { ComponentPropsWithRef } from "react";

// Provides the id="main-content" anchor the AppManager host's "Skip to main content" link lands on.
export const Main = ({ children, ...rest }: ComponentPropsWithRef<"main">) => (
  <main id="main-content" tabIndex={-1} {...rest}>
    {children}
  </main>
);
